import socketIoClient from "socket.io-client"
import { environment } from "../../environments/environment"
import { message } from "antd"
const { apiPaths: { base } } = environment

let SocketInstance = socketIoClient(base)
SocketInstance.on('connect', () => {} )

class Socket {

    constructor(metaData = {}) {
        Object.assign(this, { socketInstance: SocketInstance, ...metaData })
    }

    open = () => this.socketInstance.on('connect', () =>  {})

    emit = (event = 'employee-login') => this.socketInstance.emit(event)

}

export {
    Socket,
    SocketInstance
}